__webpack_require__.p = "https://filipemerker.github.io/micro-frontend-talk-example/";